import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { isEmpty, get, isNil } from 'lodash';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsPage from '../../components/EsmsPage';

import ConfigureAgentPanel from './ConfigureAgentPanel';

import * as ErpAgentActions from '../../actions/erpAgentActions';
import * as UiActions from '../../actions/uiActions';

import classes from './AgentNetworkPage.module.css';

class ConfigureErpAgentPage extends Component {
    state = {
        driver:         '',
        driverDisabled: true
    }

    async componentDidMount() {
        const { fetchErpAgent, location, selectedAgent } = this.props;
        const queryValues = new URLSearchParams(location.search);

        if (!queryValues.has('erpAgent')) {
            this.handleErpAgentsRoute();
            return;
        }

        if (isEmpty(selectedAgent)) {
            const result = await fetchErpAgent(queryValues.get('erpAgent'));
            if (!result) {
                this.handleErpAgentsRoute();
                return;
            }
        }

    }

    stripFileTypeHeader = file => {
        return file ? file.replace('data:application/octet-stream;base64,', '') : null;
    }

    enableAutoRefreshCheckbox = driverConfig => {
        const time = get(driverConfig, 'syncRefreshTime', null);
        return !isNil(time);
    }

    calculateAutoRefresh = driverConfig => {
        const time = get(driverConfig, 'syncRefreshTime', null);

        if (isNil(time) || time === 0) {
            return '00:00';
        }
        return time;
    }

    getScanTime = formControls => {
        const { autoRefresh, syncRefreshTime } = formControls;

        if (!autoRefresh.value) return null;

        const timeArray = syncRefreshTime.value.split(':');

        if (timeArray.length === 1) return null;

        return syncRefreshTime.value;
    }

    handleIotHubRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(`/iothub?company=${queryValues.get('company')}`);
    }

    handleErpAgentsRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(`/iothub/erpagents?company=${queryValues.get('company')}`);
    }

    handleSelectedAgentRoute = () => {
        const { history, location, selectedAgent } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(`/iothub/erpagents/manage?company=${queryValues.get('company')}&erpagent=${selectedAgent.id}`);
    }

    handleDriverSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleCancel = () => {
        this.handleSelectedAgentRoute();
    }

    handleSaveNetworkConfig = async payload => {
        const { companyInfo, selectedAgent, updateErpAgent, isLoading } = this.props;

        if (!isLoading) {
            this.props.toggleLoading(true);
            await updateErpAgent(companyInfo.companyId, selectedAgent.id, payload);
            this.props.toggleLoading(false);
        }
    }

    render() {
        const { selectedAgent, companyInfo, isLoading } = this.props;

        if (isEmpty(selectedAgent)) return null;

        return (
            <EsmsPage
                parents={[
                    companyInfo.companyName,
                    'FSM Integrations',
                    selectedAgent.name
                ]}
                title="FSM Integration Configuration"
                handlers={[
                    this.handleIotHubRoute,
                    this.handleErpAgentsRoute,
                    this.handleSelectedAgentRoute
                ]}
            >
                <div className={classes.AgentNetworkPage}>
                    <div className={classes.pageActions}>
                        <FormControl className={classes.driverSelectFormControl}>
                            <InputLabel
                                htmlFor="driver-select"
                                classes={{
                                    focused: classes.cssFocused
                                }}
                            >
                                FSM Driver
                            </InputLabel>
                            <Select
                                value={selectedAgent.agentType}
                                onChange={this.handleDriverSelectChange}
                                className={classes.driverSelect}
                                disabled={!!selectedAgent.agentType}
                                inputProps={{
                                    name: 'driver',
                                    id:   'driver-select'
                                }}
                            >
                                <MenuItem value="Signature" className={classes.selectMenuItem}>Signature</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <ConfigureAgentPanel
                            save={this.handleSaveNetworkConfig}
                            agent={selectedAgent}
                            enableAutoRefreshCheckbox={this.enableAutoRefreshCheckbox}
                            calculateAutoRefresh={this.calculateAutoRefresh}
                            getScanTime={this.getScanTime}
                            isLoading={isLoading}
                            driver={this.state.driver}
                        />
                    </div>
                </div>
            </EsmsPage>
        );
    }
}

const mapStateToProps = ({ erpAgent, ...state }) => {
    const { erpAgents, selectedAgent } = erpAgent;

    return {
        erpAgents:     Object.values(erpAgents),
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        isLoading:     state.ui.isLoading,
        selectedAgent
    };
};

const mapDispatchToProps = {
    ...ErpAgentActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfigureErpAgentPage));
